import React from "react"

interface ResumeData {
  year: string
  position?: string
  graduation?: string
  university?: string
  company?: string
  details: string
}

interface ResumeProps {
  resumeData: ResumeData
}

const Resume: React.FC<ResumeProps> = ({ resumeData }) => {
  const {year, position, graduation, university, company, details} = resumeData
  return (
    <div className="mi-cv mt-30">
      <div className="mi-cv-summary">
        <h6 className="mi-cv-year">{year}</h6>
      </div>
      <div className="mi-cv-details">
        <h5>{position || graduation}</h5>
        <h6 className="mi-cv-company">{company || university}</h6>
        <p>{details}</p>
      </div>
    </div>
  )
}

export default Resume
